module.exports = __webpack_public_path__ + "static/media/mahle.7fc5888e.svg";